import { InformationFilled } from '@teo/components/icons';

function InfoSection({ text }: any) {
  return (
    <div className="flex w-full flex-col gap-1 rounded-lg bg-tint-blue-light p-5">
      <InformationFilled className="h-6 w-6 text-tint-blue" />
      <p
        className="text-sm text-[#004795]"
        dangerouslySetInnerHTML={{
          __html: text,
        }}
      ></p>
    </div>
  );
}

export default InfoSection;
